import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '@environments/environment';
import { FetchState } from '@app/shared/models/fetch-state.model';
import { HttpService } from '@app/shared/services/http';

@Injectable({
  providedIn: 'root',
})
export class AnonymizedDataService {
  private _dataStateSubject = new BehaviorSubject<
    FetchState<Record<string, unknown>[]>
  >({
    status: 'loading',
  });
  public anonymizedDataState$ = this._dataStateSubject.asObservable();

  constructor(private httpService: HttpService) {}

  fetchAnonymizedDatas(
    reviewId: string,
    dataType: string,
    count: number,
    offset: number,
  ): void {
    const url = `${environment.apiUrl}Review/${reviewId}/${dataType}?_count=${count}&_offset=${offset}`;
    this._dataStateSubject.next({ status: 'loading' });
    this.httpService.get<{ items: Record<string, unknown>[] }>(url).subscribe({
      next: (response) => {
        this._dataStateSubject.next({
          status: 'success',
          data: response.items,
        });
      },
      error: (err) => {
        this._dataStateSubject.next({ status: 'error', error: err });
      },
    });
  }
}
